import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { BuyerApiService } from '../service/buyer-api.service';
import { SellerApiService } from '../../seller/service/seller-api.service';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { debug } from 'util';

@Component({
  selector: 'app-add-new-project',
  templateUrl: './add-new-project.component.html',
  styleUrls: ['./add-new-project.component.scss']
})
export class AddNewProjectComponent implements OnInit {

  invalidValidationMsg: string;
  newprojects: any = {
  };
  listProjects: Array<any> = [];
  listofSellers: Array<any> = [];
  serviceCategories: Array<any> = [];
  agreementFiles: Array<any> = [];
  currentProjectId: number = null;
  currentSellerId: number = null;
  agreementId: number = null;

  constructor(private globalEventsManager: GlobalEventsManager, private buyerApiService: BuyerApiService,
    private sellerApiService: SellerApiService, private cognitoService: CognitoUtil) {
    this.globalEventsManager.showNavBar(false);
  }
  ngOnInit() {
    this.getToloadNewProjects();
    this.getServiceCategories();
  }

  // Load the new Projects
  getToloadNewProjects() {
    // tslint:disable-next-line:prefer-const
    // let userDetails = this.cognitoService.getCurrentUser();
    this.buyerApiService.getAllAcceptedProjects().subscribe(res => {
      if (res != null) {
        this.listProjects = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Load service categories
  getServiceCategories() {
    this.buyerApiService.getServiceCategories().subscribe(res => {
      if (res != null) {
        this.serviceCategories = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Add new Projects
  addNewProjects(model: any, isValid: boolean): void {
    if (!isValid) {
      return;
    }
    this.buyerApiService.addNewProject(model).subscribe(res => {
      if (res != null) {
        location.reload();
      }
    }, err => {
      console.log(err);
    });
  }


  // view List of Sellers
  callListSeller(item): void {
    this.listofSellers = [];
    this.listofSellers = item.seller_list;
    if (this.listofSellers.length > 0) {
      this.currentProjectId = this.listofSellers[0].project_id;
      this.currentSellerId = this.listofSellers[0].seller_id;
      this.getFilePathAgreement(this.currentProjectId, this.listofSellers[0].seller_id);
    }
  }

  getFilePathAgreement(projectid, seller_id) {
    this.sellerApiService.getAgreementFilePath(projectid, seller_id).subscribe(res => {
      if (res != null) {
        console.log(res);
        this.agreementFiles = res;
        if (this.agreementFiles.length > 0) {
            this.agreementId = this.agreementFiles[0].project_agreement_id;
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // Agreed the project
  callAgreementBuyer(item): void {
    // tslint:disable-next-line:prefer-const
    let model = {
      project_id: item.project_id,
      seller_id: item.seller_id,
      agreement_id: this.agreementId
    };
    this.buyerApiService.buyerProjectSignAgreement(model).subscribe(res => {
      if (res != null) {
        this.listofSellers = [];
        console.log(res);
        this.getToloadNewProjects();
      }
    }, err => {
      console.log(err);
    });
  }
  callEndPointCheck() {
    this.sellerApiService.getValidateEndPoint().subscribe(res => {
      if (res != null) {
        console.log(res);
      }
    }, err => {
      console.log(err);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/buyer/add-new-project/add-new-project.component.ts